import { render, staticRenderFns } from "./OrderListDetailSection.vue?vue&type=template&id=1f235e64&scoped=true&"
import script from "./OrderListDetailSection.vue?vue&type=script&lang=js&"
export * from "./OrderListDetailSection.vue?vue&type=script&lang=js&"
import style0 from "./OrderListDetailSection.vue?vue&type=style&index=0&id=1f235e64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f235e64",
  null
  
)

export default component.exports